module.exports = __webpack_public_path__ + "f4ea397f3e5c40a867a138481b6efe2b.png";